module.exports = __webpack_public_path__ + "assets/6d443dcec92247ed0f873b877e258448.png";